<template>
  <b-container fluid>
    <b-form @submit.prevent="addNote">
      <b-row class="pb-2">
        <b-col>
          <h3>
            <b-badge variant="primary">
              Add Note
            </b-badge>
            <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
          </h3>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>Household ID</strong></b-col>
        <b-col sm="8" cols="12">{{ HHID }}</b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>Family Name</strong></b-col>
        <b-col sm="8" cols="12">{{ FamilyName }}</b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>Claim ID</strong></b-col>
        <b-col sm="8" cols="12">{{ ClaimID }}</b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>PID</strong></b-col>
        <b-col sm="8" cols="12">{{ PID }}</b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>Note written by</strong></b-col>
        <b-col sm="8" cols="12">{{ NtFromName }}</b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>For the attention of</strong></b-col>
        <b-col sm="8" cols="12">
          <b-form-select
            required
            v-model="AttentionOf"
            :options="AttentionOfOptions">
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col><strong>Note</strong></b-col>
        <b-col sm="8" cols=12>
          <div role="group">
            <b-form-textarea
              required
              id="input-note"
              v-model="Note"
              :state="noteLengthInRange"
              aria-describedby="input-note-feedback input-note-help"
              placeholder="Enter note here"
              rows="3"
              max-rows="6">
            </b-form-textarea>
            <b-form-invalid-feedback id="input-note-feedback">
              note too long
            </b-form-invalid-feedback>
            <b-form-text
              id="input-note-help">
              ({{ noteLength }}/{{ maxNoteLength }})
            </b-form-text>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="pb-2 pb-sm-0" sm="6">
          <b-button
            block
            :disabled="!noteLengthInRange || waiting"
            type="submit"
            variant="success">
            Send Note
          </b-button>
        </b-col>
        <b-col cols="12" sm="6">
          <b-button
            block
            @click="$router.go(-1)">
            Back
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { apiService } from '../_services'
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      waiting: false,
      HHID: '',
      FamilyName: '',
      ClaimID: '',
      PID: '',
      NtFromName: '', 
      AttentionOf: null,
      AttentionOfOptions: [],
      Note: '',
      maxNoteLength: 2500,
    }
  },
  created() {
    // vuex getter for user profile info
    // this.NtFrom = ...
    this.NtFromName = this.getName
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getAddNote(this.HHID)
    .then((response) => {
      vm.FamilyName = response.data.FamilyName
      vm.ClaimID = response.data.ClaimID
      vm.PID = response.data.PID
      vm.AttentionOfOptions = [
        {value: null, text: 'pick recipient'},
        ...response.data.AttentionOfOptions,
        ]
      vm.waiting = false
    })
  },
  computed: {
    ...mapGetters('auth', ['getName']),
    noteLength() {
      return this.Note.length
    },
    noteLengthInRange() {
      return this.Note.length > this.maxNoteLength ? false : true
    }
  },
  methods: {
    ...mapActions('notes', {fetchNotes: 'fetchUnreadNotes'}),
    // can only save if a note has been entered
    canSend() {
      if ((this.Note == '') || (this.AttentionOf === null)) {
        return true
      }
      return false
    },
    addNote() {
      let vm = this
      this.waiting = true
      apiService.addNewNote(this.HHID, this.AttentionOf, this.Note)
      .then(() => {
        vm.waiting = false
        console.log("note added successfully")
        this.$bvModal.msgBoxOk('Note added')
        // add user confirmation of successful note addition
        // maybe reset page to empty fields
        vm.fetchNotes()
      })
      .catch((err) => {
        vm.waiting = false
        console.log({'msg': 'error adding note', 'error': err})
        this.$bvModal.msgBoxOk('Error adding note')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AddNotePage.vue